/** Brand-safe pastel colours for kudos badges (none near the brand yellow). The API only accepts these. */
export const KUDOS_BADGE_PALETTE = ['#7fb3e0', '#a99be0', '#e0a96d', '#7fb77e', '#e58f8f', '#d68fc0', '#6fc2b4', '#9aa5b1'] as const;

/** Validates admin input for a badge; returns error messages (empty when OK). */
export function validateKudosBadge(b: { name?: string; emoji?: string; color?: string; description?: string | null }): string[] {
  const e: string[] = [];
  if (b.name !== undefined && (b.name.trim().length < 1 || b.name.trim().length > 40)) e.push('Name must be 1-40 characters');
  if (b.emoji !== undefined && (!/\p{Extended_Pictographic}|\p{Regional_Indicator}/u.test(b.emoji) || [...b.emoji].length > 8)) e.push('Pick a single emoji');
  if (b.color !== undefined && !(KUDOS_BADGE_PALETTE as readonly string[]).includes(b.color.toLowerCase())) e.push('Pick one of the brand-safe colours');
  if (b.description != null && b.description.length > 200) e.push('Description must be at most 200 characters');
  return e;
}

/** Stable key from a name: "Above & beyond!" -> "above_beyond". */
export function badgeKeyFrom(name: string): string {
  const k = name.toLowerCase().normalize('NFKD').replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 32);
  return k.length >= 2 ? k : `badge_${k || 'x'}`;
}
